export default __webpack_public_path__ + "static/media/testimonial_graphic_img.99bc5c33.png";